var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mb-3",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.payload.content))}}),_c('LinkEntity',{attrs:{"payload":_vm.payload.resources.position,"additional_data":{ center: true, resource_type: 'Position' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }